import React from "react";

function BS4_JS_Dropdown() {
  return (
    <div>
      <h1>BS4_JS_Dropdown Component</h1>
      <p>This is the BS4_JS_Dropdown tutorial page content.</p>
    </div>
  );
}

export default BS4_JS_Dropdown;
